/**
 * Shared invoice display helpers (admin UI, English labels in components).
 */

export function invoiceDisplayId(inv) {
  if (!inv) return "—";
  if (inv.invoiceNumber) return inv.invoiceNumber;
  const id = inv._id != null ? String(inv._id) : "";
  return id ? `DRAFT-${id.slice(-8)}` : "—";
}

export function invoiceStatusBadgeColor(status) {
  const map = {
    draft: "secondary",
    pending_issue: "warning",
    issued: "info",
    paid: "success",
    void: "danger",
    credited: "dark",
  };
  return map[status] || "secondary";
}

export function formatMoneyAmount(amount, currency) {
  if (amount == null || Number.isNaN(Number(amount))) return "—";
  const c = (currency || "EUR").toUpperCase().slice(0, 3);
  try {
    return new Intl.NumberFormat("en", { style: "currency", currency: c }).format(Number(amount));
  } catch {
    return `${Number(amount).toFixed(2)} ${c}`;
  }
}

export function patientDisplayName(patient) {
  if (!patient || typeof patient !== "object") return "—";
  const parts = [patient.salutation, patient.first_name, patient.last_name].filter(
    (p) => p != null && String(p).trim() !== ""
  );
  const name = parts.join(" ").trim();
  if (name) return name;
  if (patient.email) return String(patient.email);
  return "—";
}
